module.exports = __webpack_public_path__ + "static/img/bg69.f8201d98.png";